import { Injectable } from '@angular/core'
import { Observable, throwError } from 'rxjs'

export interface GeolocationPosition {
    latitude: number
    longitude: number
    accuracy: number
    altitude: number | null
    altitudeAccuracy: number | null
    heading: number | null
    speed: number | null
}

@Injectable({
    providedIn: 'root',
})
export class GeolocationService {
    getCurrentPosition(options?: PositionOptions): Observable<GeolocationPosition> {
        return new Observable((observer) => {
            if (!navigator.geolocation) {
                observer.error(new Error('La géolocalisation n\'est pas supportée par ce navigateur.'))
                return
            }


            // DOMDOM en commentaire temporairement:
            // navigator.geolocation.getCurrentPosition(
            //     (position) => {
            //         observer.next({
            //             latitude: position.coords.latitude,
            //             longitude: position.coords.longitude,
            //             accuracy: position.coords.accuracy,
            //             altitude: position.coords.altitude,
            //             altitudeAccuracy: position.coords.altitudeAccuracy,
            //             heading: position.coords.heading,
            //             speed: position.coords.speed,
            //         })
            //         observer.complete()
            //     },
            //     (error) => {
            //         observer.error(error)
            //     },
            //     options
            // )

            // en attendant, je force des valeurs manuellement
            observer.next({
                latitude: 48.8153,
                longitude: 2.506833,
                accuracy: 250,
                altitude: null,
                altitudeAccuracy: null,
                heading: null,
                speed: null,
            })
            observer.complete()


        })
    }
}
